const Filter = [
  {
    name: "cid",
    label: "Company Name",
    required: true,
    select: true,
    validationType: "number",
    getData: "companyName",
    data: "name",

    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "sid",
    label: "Site Name",
    select: true,
    getData: "siteName",
    data: "name",
  },
  {
    name: "methodId",
    label: "Method",
    getData: "methodId",
    data: "name",
  },
  {
    name: "searchText",
    label: "Search",
  },
  {
    label: "Payment Type",
    name: "paymentType",
    select: true,
  },
  {
    label: "Paid Status",
    name: "paymentStatus",
    select: true,
    data: "name",
  },
  {
    label: "Service",
    name: "serviceTitle",
    type: "text",
    input: true,
  },

  {
    name: "fromDate",
    label: "From",
    validationType: "mixed",
    date: true,
  },
  {
    name: "toDate",
    label: "To",
    validationType: "mixed",
    date: true,
  },

  {
    label: "Mobile",
    name: "mobile",
    type: "text",
    input: true,
  },
  {
    name: "printTimes",
    label: "Print Times",
    number: true,
    validationType: "number",
  },
  {
    label: "Ticket",
    name: "ticketNumber",
    number: true,
    validationType: "number",
  },
  {
    label: "Car Plate",
    name: "carPlate",
    type: "text",
    input: true,
  },
  {
    label: "Currency",
    name: "currency",
    type: "text",
  },
  {
    label: "Exchange Rate",
    name: "exchangeRate",
    type: "number",
  },
  {
    label: "Membership",
    name: "isMembership",
    checkBox: true,
  },
  {
    label: "Main Duration",
    name: "mainDuration",
    number: true,
    validationType: "number",
  },
];
export default Filter;
